import { useController } from "react-hook-form";

import useValidation from "./useValidation";
import { FieldOptions } from "../types";

type UseFieldOptions = Pick<
  FieldOptions,
  | "name"
  | "validation"
  | "customValidation"
  | "defaultValue"
  | "shouldUnregister"
>;

export function useField(props: UseFieldOptions) {
  const {
    name,
    validation,
    customValidation,
    defaultValue = "",
    shouldUnregister,
  } = props;
  const validate = useValidation({ validation });

  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { isTouched, isDirty, error },
  } = useController({
    name,
    rules: {
      validate: {
        ...validate,
        ...customValidation,
      },
    },
    defaultValue,
    shouldUnregister,
  });

  return {
    name,
    ref,
    value,
    onChange,
    onBlur,
    error,
    isTouched,
    isDirty,
  };
}
